module.exports = __webpack_public_path__ + "img/News_item_8.561b6e6d.jpg";